import { useSyncExternalStore } from 'react';

/**
 * One shared one-second tick for every live timer on the board.
 *
 * Each "Elapsed" / "Remaining" cell subscribes on its own, so a tick re-renders
 * those few hundred text nodes and nothing else — not the rows, not the
 * buttons, not the dialogs. The interval runs only while some cell is mounted.
 */
let now = Date.now();
const listeners = new Set<() => void>();
let timer: number | null = null;

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  if (timer == null) {
    now = Date.now();
    timer = window.setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, 1000);
  }
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0 && timer != null) {
      window.clearInterval(timer);
      timer = null;
    }
  };
}

export function useTick(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}
